<template>

    <div>

        <div v-show="image && image.url" v-bind:class="[(image && image.url && background != null) ? 'd-inline-block rounded p-1' : '', 'image mb-2']" v-bind:style="[(image && image.url && background != null) ? {'background': background} : null, {'width': width + 'px'}, {'aspect-ratio': cropAspectRatio}]">
            <vue-cropper style="width: 100%; height: 100%;" v-show="!disabled && cropAvailable && cropEnabled" ref="cropper" :src="image ? image.url : null" :view-mode="0" :aspect-ratio="cropAspectRatio" :auto-crop-area="1" :zoom-on-wheel="false"></vue-cropper>
            <img v-show="(!cropAvailable || (cropAvailable && !cropEnabled)) && image && image.url" v-bind:src="image ? image.url : null" ref="preview" class="img-responsive preview" alt="" style="width: 100%; height: 100%;">
        </div>

        <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-if="cropEnabled" @click="zoom(0.1)">
            <i class="fa fa-search-plus"></i>
        </a>
        <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-if="cropEnabled"  @click="zoom(-0.1)">
            <i class="fa fa-search-minus"></i>
        </a>

        <div class="mb-2" v-if="image && image.url"></div>

<!--        <p v-if="image">{{ getNameFromUrl(image) }}</p>-->

        <div>
            <a href="javascript:void(0)" class="btn btn-sm btn-warning" v-if="!disabled && cropAvailable && image && image.url" @click="cropToggle">{{ cropEnabled ? 'Anuluj kadrowanie' : 'Kadruj' }}</a>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-if="!disabled" @click="showFileManager()">
                <span v-if="image === undefined || image === null || image.url === null || image.url === undefined">Wybierz grafikę</span>
                <span v-if="image !== undefined && image !== null && image.url !== null && image.url !== undefined">Wybierz inną grafikę</span>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-danger" v-if="!disabled && image !== undefined && image !== null && image.url !== null && image.url !== undefined" @click="clear()">Usuń</a>
        </div>

    </div>

</template>

<script>
    import Image from "../classes/Image";

    export default {
        props: {
            inputName: {
                type: String,
                default: null
            },
            value: {
                type: Image,
                default: null
            },
            mimeTypes: {
                type: String,
                default: null
            },
            cropAvailable: {
                type: Boolean,
                default: false,
            },
            width: {
                type: Number,
                default: 370
            },
            cropAspectRatio: {
                type: Number,
                default: NaN
            },
            background: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                eventHub: window.eventHub,
                image: this.value,
                croppr: null,
                cropEnabled: false,
                imageChanged: false
            }
        },
        model: {
            event: 'change'
        },
        methods: {
            showFileManager() {
                this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes)
            },
            clear() {
                this.image.reset();
                this.$emit('change', this.image);
                this.cropEnabled = false;
            },
            getNameFromUrl(url) {
                return url.substring(url.lastIndexOf('/')+1);
            },
            cropToggle() {
                this.cropEnabled = !this.cropEnabled;
                this.$refs.cropper.replace(this.image.url);
            },
            zoom(percent) {
                this.$refs.cropper.relativeZoom(percent);
            }
        },
        beforeMount() {

        },
        mounted() {

            if (this.image == null) {
                this.image = new Image();
            }

            this.eventHub.$on('file-manager-selected-' + this._uid, (file) => {
                this.image.selectFromLibrary(file);
                this.$emit('change', this.image);
                this.eventHub.$emit('hide-file-manager');
                if (this.cropAvailable) {
                    this.$refs.cropper.replace(this.image.url);
                    this.cropEnabled = true;
                }
                this.imageChanged = true;
            });

            if (this.cropAvailable) {
                this.$refs.cropper.$el.addEventListener('crop', (event) => {
                    if (this.image.url) {
                        this.image.crop_changed = this.image.crop_changed
                            || this.image.crop_data == null
                            || this.image.crop_data.x !== event.detail.x
                            || this.image.crop_data.y !== event.detail.y
                            || this.image.crop_data.width !== event.detail.width
                            || this.image.crop_data.height !== event.detail.height;
                        this.image.crop_data = {
                            x: event.detail.x,
                            y: event.detail.y,
                            width: event.detail.width,
                            height: event.detail.height
                        };
                        this.$emit('change', this.image);
                    }
                });
            }

        },
        watch: {
            value: function(newVal, oldVal) {
                this.image = this.value;
                if (this.image && this.image.url) {
                    if (this.cropAvailable) {
                        this.$refs.cropper.replace(this.image.url);
                    }
                    this.imageChanged = true;
                }

            }
        }
    };
</script>

<style scoped>

    .image {
        background-image: linear-gradient(
            45deg,#ccc 25%,transparent 0),linear-gradient(
            -45deg,#ccc 25%,transparent 0),linear-gradient(
            45deg,transparent 75%,#ccc 0),linear-gradient(
            -45deg,transparent 75%,#ccc 0);
        background-size: 16px 16px;
        background-position: 0 0, 0 8px, 8px -8px, -8px 0;
    }

    .btn i {
        margin-right: 0;
    }

    .cropper-container.cropper-bg {
        width: 100% !important;
        height: 100% !important;
    }

</style>
